import { LayoutAddComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutAddComponentListItem';
import { useCreateNewJsonComponent } from '@website-editor/customComponents/hooks/useJsonBlobStorageUtils';
import React from 'react';
import { AdminSidebarComponentProps } from '@website-editor/customComponents/JsonComponent.types';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { FaqConfig } from './Faq.config';
import { Help } from '@withjoy/joykit/icons';
import { TextV2 } from '@withjoy/joykit';
import { useNavigationPaneContext } from '@website-editor/context/NavigationPaneContext/NavigationPane.context';
import { useUpdateWebsitePreview } from '@website-editor/hooks/useUpdateWebsitePreview';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { JsonDataContainerFragment } from '@graphql/generated';
import { CUSTOM_PAGE_ACTIONS } from '../CustomComponents.constants';
import { useTranslation } from '@shared/core';
import { FaqData } from './Faq.types';

export const FaqGrabber = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('faqCustomComponent');
  const faqData = props.componentData.containerContent.content as FaqData;
  const itemCount = faqData?.items?.length || 0;

  return (
    <SimpleGrabHandle
      title={tq`FAQs`}
      subTitle={itemCount === 1 ? tq`${itemCount} item` : tq`${itemCount} items`}
      icon={<Help size={32} />}
      {...props}
    ></SimpleGrabHandle>
  );
};

export const FaqAdd = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('faqCustomComponent');
  const { createNewJsonComponent } = useCreateNewJsonComponent(props.eventHandle);
  const { setRefetchQueries } = useCustomComponentStateContext<JsonDataContainerFragment>();
  const { replaceAndNavigateToScreen } = useNavigationPaneContext();
  const { updateWebsitePreview } = useUpdateWebsitePreview();

  const handleClick = async () => {
    const initialData: FaqData = {
      items: [],
    };

    await createNewJsonComponent({
      schemaURL: FaqConfig.schemaUrl,
      type: FaqConfig.componentType,
      initialData,
      containerId: props.containerId,
      sortOrder: props.componentData?.sortOrder,
    }).then(result => {
      if (result?.containerData?.data) {
        setRefetchQueries(['PageContainerBySlug']);
        updateWebsitePreview();
        replaceAndNavigateToScreen(CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS);
      }
    });
  };

  return (
    <LayoutAddComponentListItem onClick={handleClick}>
      <Help size={48} />
      <TextV2
        typographyVariant="hed2"
        textAlign="left"
      >
        {tq`FAQs`}
      </TextV2>
    </LayoutAddComponentListItem>
  );
};
